import { useDispatch } from 'react-redux';

import {
  dragTileOver,
  dragEnd,
} from '../../../lib/redux/campaignDnd/campaignDndSlice';

export const useCampaignDnd = ({ setActiveTile }) => {
  const dispatch = useDispatch();

  const findContainer = ({ id, data }) => {
    if (id.includes('post')) return id;
    if (['suggested', 'unscheduled', 'archived'].includes(id)) return id;

    return data.current.status;
  };

  const handleDragStart = event => {
    setActiveTile(event.active.data.current);
  };

  const handleDragOver = event => {
    const { active, over } = event;

    if (!over) {
      return;
    }

    const activeContainer = findContainer(active);
    const overContainer = findContainer(over);

    if (
      !activeContainer ||
      !overContainer ||
      activeContainer === overContainer ||
      overContainer === 'archived'
    ) {
      return;
    }

    dispatch(dragTileOver({ activeContainer, overContainer, active }));
  };

  const handleDragEnd = event => {
    const { active, over } = event;

    if (!over) {
      return;
    }

    const activeContainer = findContainer(active);
    const overContainer = findContainer(over);

    if (
      !activeContainer ||
      !overContainer ||
      activeContainer !== overContainer ||
      overContainer === 'archived'
    ) {
      return;
    }

    dispatch(dragEnd({ tile: active.data.current, overId: over.id }));

    setActiveTile(null);
  };

  return {
    handleDragEnd,
    handleDragOver,
    handleDragStart,
  };
};
